import "./buildFleet.css";
import ArielView1500E from "../../../assets/png/ArielView1500E.png";

const BuildFleet = () => {
  return (
    <div className="relative">
      <div class="grid grid-cols-1 2xl:grid-cols-5 gap-4">
        <div className="2xl:col-span-2 col-span-1">
          <div className="ArielView1500E min-h-[500px] 2xl:border-r-[8px] border-[#b4875e] border-[0px]" />
        </div>
        <div className="2xl:col-span-3 col-span-1 2xl:pt-[137px] sm:pt-[90px] pt-[60px] 2xl:pb-[119px] sm:pb-[80px] pb-[50px] 2xl:text-end text-center custom-container">
          <div className="2xl:max-w-[700px] max-w-full">
            <div className="font-[Rockwell] 2xl:text-[40px] xl:text-[30px] lg:text-[25px] md:text-[20px] sm:text-[17px] text-[15px] font-extrabold	lg:mb-[20px] sm:mb-[20px] mb-[15px]">
              ADVANCED TELEMATICS
            </div>
            <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-extrabold lg:mb-[20px] sm:mb-[20px] mb-[15px]">
              CHECK BATTERY HEALTH ON FLEET VEHICLES REMOTELY
            </div>
            <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal lg:mb-[50px] sm:mb-[30px] mb-[10px]">
              The Tuatara's advanced telematics system provides real-time monitoring and management capabilities for
              your vehicle or fleet. This sophisticated system allows you to remotely check the battery health, ensuring
              optimal performance and longevity. With detailed insights into battery status, charge levels, and usage
              patterns, fleet managers can make informed decisions about maintenance and operational efficiency.
            </div>

            <div>
              <button
                className="bg-[#F2F2F2] border-[#5B792E] border-[4px] rounded font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#5B792E] 2xl:px-[150px] md:px-[48px] sm:px-[30px] px-[20px] 2xl:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                BUILD MY FLEET
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BuildFleet;
